import { ArrowRight } from "lucide-react";
import { useLang } from "../../i18n/LanguageContext";
import { waLink } from "../../lib/site";

export const Trust = () => {
  const { t } = useLang();

  const scrollToSendLink = () => {
    const el = document.querySelector("[data-testid='send-link-section']");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section data-testid="trust-section" className="bg-white pb-20 md:pb-28">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="relative overflow-hidden rounded-[2rem] bg-sinovar-navy px-6 py-16 md:px-14 md:py-20 text-center">
          <div className="pointer-events-none absolute -right-24 -top-24 h-80 w-80 rounded-full bg-sinovar-blue/25 blur-3xl" />
          <div className="pointer-events-none absolute -left-20 -bottom-20 h-72 w-72 rounded-full bg-sinovar-red/15 blur-3xl" />
          <div className="relative mx-auto max-w-2xl">
            <h2 className="font-display text-3xl md:text-5xl font-bold tracking-tight text-white leading-[1.08]">
              {t.trust.title}
            </h2>
            <p className="mx-auto mt-5 max-w-xl text-base md:text-lg text-white/60 leading-relaxed">{t.trust.sub}</p>
            <div className="mt-9 flex flex-col sm:flex-row justify-center gap-3">
              <a
                href={waLink(t.hero.waMsg)}
                target="_blank"
                rel="noreferrer"
                data-testid="trust-talk-cta"
                className="inline-flex items-center justify-center gap-2 rounded-lg bg-sinovar-blue px-8 py-4 text-[15px] font-semibold text-white hover:bg-[#0b3c8a] transition-colors"
              >
                {t.trust.cta}
                <ArrowRight className="h-4 w-4" />
              </a>
              <button
                onClick={scrollToSendLink}
                data-testid="trust-sendlink-cta"
                className="inline-flex items-center justify-center rounded-lg border border-white/20 bg-white/5 px-8 py-4 text-[15px] font-semibold text-white hover:bg-white/10 transition-colors"
              >
                {t.trust.secondary}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
